import React from 'react';
import styled from 'styled-components';
import { useStoreActions, useStoreState } from 'easy-peasy';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { trackEvent } from '~/utils';

const Wrapper = styled.div`
  margin-left: auto;

  .MuiTypography-body1 {
    font-size: 13px;
    font-family: ${(p) => p.theme.fonts.sans};
    line-height: 1.2;
  }

  .MuiIconButton-root {
    padding: 0 0 0 8px;
  }

  .MuiRadio-colorPrimary {
    color: ${(p) => p.theme.colors.interaction};
  }
`;

const ViewSwitcher = () => {
  const setRelView = useStoreActions((actions) => actions.app.setRelView);
  const isRelView = useStoreState((state) => state.app.isRelView);
  const value = isRelView ? 'rel' : 'eur';

  const onChange = (evt) => {
    const nextIsRel = evt.target.value === 'rel';
    trackEvent('set_yaxis', nextIsRel ? 'percentage' : 'euro');
    setRelView(evt.target.value === 'rel');
  };

  return (
    <Wrapper>
      <RadioGroup
        style={{ marginLeft: 'auto' }}
        name="relview"
        value={value}
        onChange={onChange}
      >
        <FormControlLabel
          value="rel"
          control={<Radio size="small" disableRipple />}
          label="Einkommensteuer in Prozent des Einkommens"
          labelPlacement="start"
        />
        <FormControlLabel
          value="eur"
          control={<Radio size="small" disableRipple />}
          label="Einkommensteuer in Euro pro Jahr"
          labelPlacement="start"
        />
      </RadioGroup>
    </Wrapper>
  );
  //   <ButtonWrapper style={{ marginLeft: 'auto' }}>
  //     <Button
  //       isActive={!isRelView}
  //       onClick={() => {
  //         trackEvent('set_yaxis', 'euro');
  //         setRelView(false);
  //       }}
  //     >
  //       Euro im Jahr
  //     </Button>
  //     <Button
  //       isActive={isRelView}
  //       onClick={() => {
  //         trackEvent('set_yaxis', 'percentage');
  //         setRelView(true);
  //       }}
  //     >
  //       Prozent des Einkommens
  //     </Button>
  //   </ButtonWrapper>
  // );
};

export default ViewSwitcher;
